import { SwitchTask } from './switchTask.types'

export const createSwitchTask = ({
  name,
  taskReferenceName,
  inputParameters,
  decisionCases,
  defaultCase,
  expression,
  evaluatorType
}: Omit<SwitchTask, 'type'>): SwitchTask => {
  return {
    type: 'SWITCH',
    name,
    taskReferenceName,
    inputParameters,
    decisionCases,
    defaultCase,
    evaluatorType,
    expression
  }
}
